import React from 'react';
import PolicyLayout from './PolicyLayout';

const PrivacyPolicyPage: React.FC = () => (
  <PolicyLayout title="Privacy Policy" lastUpdated="August 1, 2026">
    <section>
      <h2>1. Information We Collect</h2>
      <p>We collect information you provide directly to us when you create an account, place an order, or contact us:</p>
      <ul>
        <li>Name, email address, phone number</li>
        <li>Shipping and billing address</li>
        <li>Payment information (processed securely — we do not store card details)</li>
        <li>Order history and preferences</li>
      </ul>
    </section>

    <section>
      <h2>2. How We Use Your Information</h2>
      <p>We use the information we collect to:</p>
      <ul>
        <li>Process and deliver your orders</li>
        <li>Send order confirmations and shipping updates</li>
        <li>Respond to your questions and support requests</li>
        <li>Improve our products and services</li>
        <li>Send promotional offers (only with your consent)</li>
      </ul>
    </section>

    <section>
      <h2>3. Information Sharing</h2>
      <p>We do not sell, trade, or rent your personal information to third parties. We may share your information only with:</p>
      <ul>
        <li>Delivery partners to fulfil your orders</li>
        <li>Payment processors for secure transactions</li>
        <li>Legal authorities when required by law</li>
      </ul>
    </section>

    <section>
      <h2>4. Data Security</h2>
      <p>We implement industry-standard security measures including SSL encryption to protect your personal information. However, no method of transmission over the internet is 100% secure.</p>
    </section>

    <section>
      <h2>5. Cookies</h2>
      <p>We use cookies to enhance your browsing experience, remember your preferences, and analyse site traffic. You can disable cookies in your browser settings, though some features may not function properly.</p>
    </section>

    <section>
      <h2>6. Your Rights</h2>
      <p>You have the right to:</p>
      <ul>
        <li>Access the personal data we hold about you</li>
        <li>Request correction of inaccurate data</li>
        <li>Request deletion of your account and data</li>
        <li>Opt out of marketing communications</li>
      </ul>
    </section>

    <section>
      <h2>7. Contact Us</h2>
      <p>
        <strong>SASTA DEAL PRIVATE LIMITED</strong><br />
        Floor No. Gr - Fr, Building No. 114/K,<br />
        Raja S.C. Mullick Road, Near Naktala, Garia,<br />
        Kolkata, West Bengal – 700047<br />
        Email: <strong><a href="mailto:sastadealpvt@gmail.com">sastadealpvt@gmail.com</a></strong>
      </p>
    </section>
  </PolicyLayout>
);

export default PrivacyPolicyPage;
